import axios from 'axios';

import routes from 'app/routes';

const prepareFormDataForSend = (values) => ({
  first_name: values.firstName,
  last_name: values.lastName,
  email: values.email,
  company_name: values.company,
});

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.affiliates.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', affiliates: resp.data.data });
      });
  },

  create: (dispatch, values, onSuccess, onError) => {
    axios
      .post(routes.api.users.registration, {
        user: { ...prepareFormDataForSend(values) },
        affiliate: 1,
        admin_create: 1,
      })
      .then((_resp) => {
        onSuccess();
      })
      .catch((error, _data) => {
        onError(error.response.data.errors);
      });
  },

  requestTraining: (dispatch, affiliateId) => {
    axios
      .patch(routes.api.affiliates.requestTraining(affiliateId))
      .then((resp) => {
        dispatch({ type: 'UPDATE', affiliate: resp.data.data });
      });
  },

  approveTraining: (dispatch, affiliateId) => {
    axios
      .patch(routes.api.affiliates.approveTraining(affiliateId))
      .then((resp) => {
        dispatch({ type: 'UPDATE', affiliate: resp.data.data });
      });
  },

  invite: (dispatch, affiliateId, callback) => {
    axios
      .post(routes.api.affiliates.invite(affiliateId))
      .then(() => {
        callback();
      });
  },

  delete: (dispatch, affiliateId) => {
    axios
      .delete(routes.api.affiliates.destroy(affiliateId))
      .then((_resp) => {
        dispatch({ type: 'DELETE', affiliateId });
      });
  },
};
